<div id="navigation" class="dispatch-filter">
  <div class="filter-row" [formGroup]="filterForm">
    <div ngbDropdown class="d-inline-block" class="type-filter component">
      <button class="btn type-filter-btn filter-btn" id="dropdownForm" ngbDropdownToggle>{{getSelectedTask()}}</button>
      <div ngbDropdownMenu aria-labelledby="dropdownForm">
        <mat-label>Task Status</mat-label>
        <span>
          <ul formArrayName="taskStatus">
            <li *ngFor="let opt of taskStatusOpts; let i = index">
              <mat-checkbox value="{{ opt.name }}" color="primary" [formControlName]="i">
                <!--(change)="updateSubtask($event)"-->
                {{ opt.name }}
              </mat-checkbox>
            </li>
          </ul>
        </span>
        <mat-label>Task Type</mat-label>
        <span>
          <ul formArrayName="taskTypes">
            <li *ngFor="let opt of taskTypeOpts; let i = index">
              <mat-checkbox value="{{ opt.name }}" color="primary" [formControlName]="i">
                {{ opt.header }}
              </mat-checkbox>
            </li>
          </ul>
        </span>
      </div>
    </div>

    <mat-button-toggle-group name="flightStatus" aria-label="" class="flight-status component"
      formControlName="fltStatus" hideSingleSelectionIndicator="true">
      <mat-button-toggle value="InboundFlight" (click)="filterFltStatus()">Flt Inbound</mat-button-toggle>
      <mat-button-toggle value="OutboundFlight" (click)="filterFltStatus()">Flt Outbound</mat-button-toggle>
    </mat-button-toggle-group>

    <mat-form-field appearance="outline" class="filter-driver" subscriptSizing="dynamic">
      <mat-select placeholder="Driver" formControlName="driver">
        <mat-option value="">-All-</mat-option>
        <mat-option *ngFor="let driver of drivers" [value]="driver.driverId">{{getDriverSummaryDisplayName(driver)}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search-filter" subscriptSizing="dynamic">
      <input matInput formControlName="searchText" placeholder="Search"
        (keyup.enter)="dispatchService.isDispatchFilterOn ? refreshDispatchData() : toggleApplyFilter()">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <div class="filter-row" [formGroup]="filterForm">
    <div ngbDropdown #savedFiltersDropdown="ngbDropdown" class="d-inline-block" class="type-filter component">
      <button class="btn type-filter-btn filter-btn" id="dropdownForm" ngbDropdownToggle>Filter</button>
      <div ngbDropdownMenu aria-labelledby="dropdownForm" class>
        <mat-label>Saved Filters</mat-label>
        <span>
          <ul class="saved-filter-list">
            <li *ngIf="!savedFilters.length; else savedFiltersTemplate">No filter selected</li>
            <ng-template #savedFiltersTemplate>
              <li *ngFor="let filter of savedFilters" (click)="savedFiltersDropdown.close(); applySavedFilter(filter)">
                <span>{{ filter.filterName }}</span>
                <button mat-button (click)="$event.stopPropagation(); deleteSavedFilter(filter)">
                  <mat-icon>close</mat-icon>
                </button>
              </li>
            </ng-template>
          </ul>
        </span>
      </div>
    </div>
    <app-time-picker class="date-filter" (result)="setFilterDate($event)" [disableTimePickers]="true"
      [dateTimeString]="filterForm.get('dispatchDate').value" [minDate]="minFilterDate"></app-time-picker>
    <mat-form-field appearance="outline" class="offset-filter" subscriptSizing="dynamic">
      <mat-select formControlName="offsetHours">
        <mat-option *ngFor="let offset of hourOffsets" [value]="offset">{{ offset >= 0 ? '+' : '' }}{{ offset }} hour(s)
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="relative-container">
      <button *ngIf="dispatchService.isDispatchFilterOn" type="button" class="filterBadge"
        matTooltip="Clear Filter" aria-label="Clear filter" (click)="toggleApplyFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button mat-button class="filter-icon-button filter-button" [class.checked]="dispatchService.isDispatchFilterOn"
        matTooltip="Apply Filter" (click)="toggleApplyFilter()">
        <mat-icon class="apply-filter-button">filter_alt</mat-icon>
      </button>
    </div>
    <button mat-button class="filter-icon-button" (click)="refreshDispatchData()" [disabled]="!dispatchService.isDispatchFilterOn">
      <span *ngIf="isLoadingFilter; else syncIcon" class="spinnerGif-dispatchFilter"></span>
      <ng-template #syncIcon>
        <mat-icon>sync</mat-icon>
      </ng-template>
    </button>
    <button mat-button class="filter-icon-button" matTooltip="Save Filter" (click)="saveFilter()">
      <mat-icon>save</mat-icon>
    </button>
    <button mat-button class="filter-icon-button eraser-button" matTooltip="Reset Filter" (click)="resetFilter()">
      <mat-icon svgIcon="icon-eraser"></mat-icon>
    </button>
  </div>

</div>